import {
    Collapse,
    Table,
    TableContainer,
    Tbody,
    Td,
    Text,
    Tfoot,
    Th,
    Thead,
    Tr
} from '@chakra-ui/react'
import { useState } from 'react'
import { storagePage } from '../../storage'
import Card from '../../Components/Card'
import StatBox from '../../Components/StatBox'
import StatCard from '../../Components/StatCard'
import ViewDetailButton from '../../Components/ViewDetailButton'
import StatDivider from 'pages/CashRegister/Components/StatDivider'

export default function DiscountSales() {
    const [showDetail, setShowDetail] = useState(false)

    const { cashboxMovements } = storagePage
    const data = cashboxMovements.map(cm => cm.dataItemsDiscountDes).flat()
    const quantity = data.length
    const total = cashboxMovements.reduce(
        (acc, curr) => acc + curr.totalSaleItemsDiscountDes,
        0
    )

    return (
        <Card direction="column" gridGap={4} w="full" overflow="auto">
            <Text as="b" fontSize="xl" align="center" w="full">
                Ventas con descuento
            </Text>
            <StatCard>
                <StatBox label="N° Ventas" value={quantity} />
                <StatDivider />
                <StatBox label="Total" value={`S/${total.toFixed(2)}`} />
            </StatCard>
            <ViewDetailButton
                showDetail={showDetail}
                setShowDetail={setShowDetail}
            />
            <Collapse in={showDetail}>
                <TableContainer overflow="auto" w="full">
                    <Table size="sm" w="full">
                        <Thead>
                            <Tr>
                                <Th>Fecha</Th>
                                <Th>Comprobante</Th>
                                <Th>Real</Th>
                                <Th>Descuento</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {data.map((movement, i) => (
                                <Tr key={i}>
                                    <Td>{movement.date}</Td>
                                    <Td>{movement.comprobante}</Td>
                                    <Td>{movement.real}</Td>
                                    <Td isNumeric>{movement.discount}</Td>
                                </Tr>
                            ))}
                        </Tbody>
                        <Tfoot>
                            <Th colSpan={3}>Total</Th>
                            <Th isNumeric>S/{total.toFixed(2)}</Th>
                        </Tfoot>
                    </Table>
                </TableContainer>
            </Collapse>
        </Card>
    )
}
